// Material UI
import { DatePicker } from "@mui/lab";
import { TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    backgroundColor: theme.palette.common.white,
    borderRadius: ".5rem",
  },
  inputDisabled: {
    width: "100%",
    backgroundColor: theme.palette.grey[100],
    borderRadius: ".5rem",
  },
  errorText: {
    marginTop: ".5rem",
    marginLeft: "1rem",
    color: theme.palette.warning.dark,
    fontWeight: "bold",
  },
  dateTime: {
    backgroundColor: theme.palette.common.white,
    borderRadius: ".5rem",
  },
  datePicker: {
    "& MuiOutlinedInput-notchedOutline": {
      borderColor: "red !important",
    },
  },
}));

interface StyledDatepickerProps {
  testId?: string;
  disabled?: boolean;
  value: number | string | null;
  label: string;
  onChange: (date: string | number | null, keyboardInputValue?: string | undefined) => void;
  errorText?: string;
  error?: boolean | undefined;
}

const StyledDatePicker: React.FC<StyledDatepickerProps> = ({
  testId,
  disabled,
  value,
  label,
  onChange,
  error,
  errorText,
}) => {
  const classes = useStyles();
  return (
    <div>
      <DatePicker
        label={label}
        value={value}
        inputFormat="DD-MM-YYYY"
        disabled={disabled}
        onChange={onChange}
        className={classes.datePicker}
        renderInput={(params: any) => (
          <TextField
            {...params}
            data-test-id={testId}
            className={classes.dateTime}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
      />

      {error && errorText && (
        <div className={classes.errorText}>
          <Typography variant="h5">{errorText}</Typography>
        </div>
      )}
    </div>
  );
};

export { StyledDatePicker };
